import { apiClient } from './client';
import type { AuthUser } from '../types';

export interface AuthConfig {
  googleConfigured: boolean;
  devBypassEnabled: boolean;
}

export const authApi = {
  async me(): Promise<AuthUser> {
    const { data } = await apiClient.get<{ user: AuthUser }>('/auth/me');
    return data.user;
  },
  async config(): Promise<AuthConfig> {
    const { data } = await apiClient.get<AuthConfig>('/auth/config');
    return data;
  },
  async devLogin(): Promise<AuthUser> {
    const { data } = await apiClient.post<{ user: AuthUser }>('/auth/dev-login');
    return data.user;
  },
  async logout(): Promise<void> {
    await apiClient.post('/auth/logout');
  },
  googleLoginUrl(): string {
    const base = import.meta.env.VITE_API_BASE_URL ?? '/api';
    return `${base}/auth/google/start`;
  },
};
